module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "四好运动员",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailSihao')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ddb5b52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailShenbao.vue
// module id = 2335
// module chunks = 0